
function Top() {
    return (
        <div className="panel__top">
            <div className="panel__top-menu-btn">

            </div>
            <input className="panel__top-search" placeholder="Search" className="panel__top-search" type="text"></input>
            <div className="panel__top-logo">

            </div>
        </div>
    )
}


export default Top;
